export const LampType = {
  Lamp: {
    value: 'LampType',
    describe: 'Lamp',
    image: 'Lamp.svg',
  },

  LampSrc: [
    {
      name: 'Lamp',
      value: 'Lamp.svg',
    },
  ],
}
